import { Routes } from '@angular/router';
import { RelatedPageComponent } from './pages/related-page/related-page.component';
import { ChosePageTypeComponent } from './pages/chose-page-type/chose-page-type.component';
import { SearchComponent } from './pages/search/search.component';
import { ApiConfig } from './services/api.config';
import { inject } from '@angular/core';
import { ContentService } from './services/content.service';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { SignupComponent } from './pages/auth/signup/signup.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { RelatedPublicationsComponent } from './pages/related-publications/related-publications.component';
import { MyTopicsComponent } from './pages/my-topics/my-topics.component';
import { ManageMyTopicsComponent } from './pages/manage-my-topics/manage-my-topics.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'en/home',
    resolve: {
      config: () => inject(ApiConfig).initAppConfig(),
      menu: () => inject(ContentService).getMainMenu(),
    },
  },
  {
    path: ':fr-loc',
    children: [
      {
        path: 'signup',
        component: SignupComponent,
        title: 'Signup',
      },
      {
        path: 'profile',
        component: UserProfileComponent,
        title: 'Profile',
      },
      {
        path: 'my-topics',
        component: MyTopicsComponent,
        title: 'My Topics',
      },
      {
        path: 'manage-my-topics',
        component: ManageMyTopicsComponent,
        title: 'Manage topics',
      },
      {
        path: 'search',
        component: SearchComponent,
        title: 'Search',
      },
      {
        path: 'tag-related/:ID',
        component: RelatedPageComponent,
        title: 'Related',
        pathMatch: 'full',
      },
      {
        path: 'related-publications',
        component: RelatedPublicationsComponent,
        title: 'Related publications',
        pathMatch: 'full',
      },
      {
        path: 'related/:ID',
        component: RelatedPageComponent,
        title: 'Related',
        pathMatch: 'full',
      },
      {
        path: 'error/:CODE',
        component: ErrorPageComponent,
        title: 'Error',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: ChosePageTypeComponent,
        pathMatch: 'full',
      },
    ],
  },
];
